export const hideLoader = () => {
	const loaderContainer = document.getElementById('loader-container');
	if (!loaderContainer) return
	loaderContainer.classList.add('hidden');
}
